// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pt-0";
export var animationContainer = "_pt-1";
export var itemPrice = "_pt-a";
export var itemizedContent = "_pt-9";
export var itemizedHeader = "_pt-7";
export var itemizedRow = "_pt-8";
export var itemizedSection = "_pt-6";
export var modalContent = "_pt-2";
export var orderName = "_pt-3";
export var refundOption = "_pt-4";
export var refundOptionsContainer = "_pt-5";
export var shippingLabel = "_pt-b";
export var totalRow = "_pt-c";